import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'antd';
import './App.css';

const PayCancel = () => {
    const history = useHistory();

    const handleGoHome = () => {
        history.push('/app/welcome');
    };

    return (
        <div className="pay-cancel-page" style={{ padding: '20px', textAlign: 'center' }}>
            <h2>Payment Cancelled</h2>
            <p>Your payment has been cancelled. No charges have been made to your account.</p>
            <p>If you wish to complete your purchase, please try again.</p>
            <Button type="primary" onClick={handleGoHome}>
                Go to Home
            </Button>
        </div>
    );
};

export default PayCancel;